import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.NoCompaniesPage.WhatYouCanDoNow', {
    title: 'What else you can do right now',
    knowledge: ' Visit Knowledge Base',
    setup: 'Setup your own Organisation',
});
